// Wave-J (loop-engineering nota-10) — HARD STOP por orçamento do RUN local.
// O vídeo/doutrina: "hard stop by token budget"; o cloud DO já tinha maxCostUsd,
// o loop LOCAL confiava só em maxIterations (40 iterações de um modelo caro num
// doom-loop custam dinheiro real). Puro; o spine chama após cada addUsage.

import { priceTurnUsage } from '../turnTelemetry.js';

// Tetos DEFAULT generosos (um run legítimo grande fica bem abaixo; um runaway
// bate). Override por cfg.maxCostUsd/cfg.maxTokensOut; null = teto desligado.
export const DEFAULT_MAX_RUN_COST_USD = 5;
const DEFAULT_MAX_RUN_TOKENS_OUT = 400_000;

/**
 * @param {{input_tokens?: number, output_tokens?: number}} usageTotals acumulado do run
 * @param {string} modelId
 * @param {{maxCostUsd?: number|null, maxTokensOut?: number|null}} [caps]
 * @returns {{reason: string, costUsd: number, tokensOut: number}|null} null = dentro do orçamento
 */
export function budgetExceeded(usageTotals, modelId, { maxCostUsd = DEFAULT_MAX_RUN_COST_USD, maxTokensOut = DEFAULT_MAX_RUN_TOKENS_OUT } = {}) {
  const tokensOut = Number(usageTotals?.output_tokens) || 0;
  const costUsd = Number(priceTurnUsage(usageTotals || {}, modelId)) || 0;
  if (maxCostUsd != null && costUsd >= maxCostUsd) {
    return { reason: `custo acumulado do run US$${costUsd < 0.01 ? costUsd.toFixed(5) : costUsd.toFixed(2)} atingiu o teto US$${maxCostUsd}`, costUsd, tokensOut };
  }
  if (maxTokensOut != null && tokensOut >= maxTokensOut) {
    return { reason: `${tokensOut} tokens de saída atingiram o teto ${maxTokensOut}`, costUsd, tokensOut };
  }
  return null;
}
